import SearchBar from 'components/common/dataTable/searchBar'
import PendingErpSyncRmaTable from 'components/pendingErpSync/pendingErpSyncRmaTable'
import { Helmet } from 'react-helmet'

const PendingErpSyncRma = () => {
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Failed RMA</title>
      </Helmet>

      <div
        className={
          'mb-2 flex flex-wrap items-center justify-between  md:mb-0 md:flex-nowrap'
        }
      >
        <h3 className="title">Failed ERP Sync RMA</h3>
        <SearchBar placeholder="Search by Order No or Rma No" />
      </div>

      <PendingErpSyncRmaTable />
    </>
  )
}

export default PendingErpSyncRma
